import React, { useState} from 'react';
import { Dialog,Box, IconButton} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { styled } from '@mui/material/styles'; 
import BtnPrimary from "./PrimaryButton";
import BtnSecondary from "./SecondaryButton";
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

import { tokens } from "../theme";
const TextBox = styled(Box)({
    display: "block",
});

const CustomCalendarHeaderRoot = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 16px',
    alignItems: 'center',
  });
  
function DateSelectDialog({ open, onClose, onSelect}) {
  const [selectedDate, setSelectedDate] = useState(null);
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleContinue = () => {
    const formattedDate = selectedDate.format('YYYY-MM-DD');
    onSelect(formattedDate);
  };

  function CustomCalendarHeader(props) {
    const { currentMonth, onMonthChange } = props;
    const selectNextMonth = () => onMonthChange(currentMonth.add(1, 'month'), 'left');
    const selectPreviousMonth = () => onMonthChange(currentMonth.subtract(1, 'month'), 'right');
  
    return (
      <CustomCalendarHeaderRoot sx={{width:"100%"}}>
          <IconButton onClick={selectPreviousMonth} title="Previous month">
            <ChevronLeft />
          </IconButton>
          <TextBox sx={{fontSize: "1rem", lineHeight: 1.7, color:"#8C3B5E"}}>
            {currentMonth.format('MMMM YYYY')}
          </TextBox>
          <IconButton onClick={selectNextMonth} title="Next month">
            <ChevronRight />
          </IconButton>
       </CustomCalendarHeaderRoot>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={()=>{onClose()}} 
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "1.5rem",
        }
      }}
    >
        <TextBox sx={{width:"100%", textAlign:"center", fontSize: "1rem", lineHeight: 1.7, fontWeight:"500", color: "#5E2540", marginBottom: "1.5rem" }}>
          Select Date
        </TextBox>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StaticDatePicker
            slots={{ calendarHeader: CustomCalendarHeader }}
            onChange={handleDateChange}
            value={selectedDate}
            showDaysOutsideCurrentMonth
            // disablePast
            disableHighlightToday
            dayOfWeekFormatter={(_day, weekday) => `${weekday.format('ddd')}`}
            sx={{
              width: "100%",
              border: "none",
              padding: 0,
              "& .MuiPickersToolbar-root": {
                display: "none"
              },
              "& .MuiDialogActions-root": {
                display: "none"
              },
              "& .MuiPickersLayout-contentWrapper":{
                borderRadius:"12px",
                border:"1px solid #EAD8CC",
                boxShadow: "0 16px 40px -20px rgba(42,29,34,0.22)",
              },
              "& .MuiDayCalendar-root":{
                width:"320px"
              },
              "& .MuiTypography-root":{
                fontSize: "0.8125rem",
                lineHeight:1.5,
                marginInline: "0.5rem",
                marginBottom: "0.25rem",
                color:tokens.infoText
              },
              "& .MuiButtonBase-root":{
                fontSize: "0.8125rem",
                lineHeight:1.5,
                marginInline: "0.5rem",
                marginBottom: "0.25rem",
              },
            }}
          />
        </LocalizationProvider>
        <Box style={{display:"flex", gap: "1.5rem", justifyContent:"space-between", width:"100%", marginTop: "1.5rem"}}>
           <BtnPrimary onClick={handleContinue} sx={{flex:"1", borderRadius: '8px' }}>Apply</BtnPrimary>
           <BtnSecondary onClick={onClose} sx={{ flex:"1", borderRadius: '8px' }}>Cancel</BtnSecondary>
        </Box>
    </Dialog>
  );
}

export default DateSelectDialog;

